import { observer } from 'mobx-react';
import React from 'react';
import { withCheckoutStore } from '../../context';
import { CheckoutStore } from 'src/mobx/checkoutStore';
import { booleanToNumber, getWalletCurrency } from 'src/utils/helpers';
import './style.scss';
import { PRODUCT_TYPE } from '~/types/product';
import { appStore } from '~/mobx/appStore';
import { localeStore } from '~/mobx/localesStore';
import Icon from '~/view/components/Controls/Icon/Icon';
import { Icons } from '~/assets/fonts/Icons/icons';
import Switcher from '~/view/components/Controls/Switcher/Switcer';
import { formatPrice } from '~/utils/formatter';
import { TBooleanInNumber } from '~/types/main';
import { messagesStore } from '~/view/containers/Messages';

// @ts-ignore
@withCheckoutStore
@observer
export default class CheckoutWallet extends React.Component<{ checkoutStore?: CheckoutStore }, {}> {
  get checkoutStore() {
    return this.props.checkoutStore!;
  }

  onChange = () => {
    if (this.disabled) return;
    this.checkoutStore.toggleUseWallet(booleanToNumber(!this.checkoutStore.params.use_wallet));
  };

  handleTermsClick = () => {
    messagesStore.addMessage({
      title: localeStore.t('consumer_wallet_tc_popup_hdr'),
      message: localeStore.t(
        appStore.settings?.is_wallet_combo_payment ? 'consumer_wallet_tc_bodytext_updated_hdr' : 'consumer_wallet_tc_bodytext_hdr',
        { value: `${appStore.settings?.wallet_usage_limit}%` }
      ),
      options: [{ title: localeStore.t('close'), stretched: true }],
      contentClassName: 'w-35',
    });
  };

  get disabled(): boolean {
    return !this.checkoutStore.dependencies.customer?.wallet?.balance;
  }

  public render() {
    const { params, dependencies } = this.checkoutStore;

    const withMeal =
      this.checkoutStore.dependencies.products.some(
        (product) => product.type === PRODUCT_TYPE.MEAL_COMBO || product.type === PRODUCT_TYPE.DEAL_COMBO
      ) && !appStore.settings?.is_wallet_combo_payment;

    if (
      !appStore.settings?.is_wallet ||
      !dependencies.customer ||
      !dependencies.branch?.is_wallet ||
      !this.checkoutStore.dependencies.customer?.wallet?.balance ||
      withMeal ||
      Boolean(this.checkoutStore.calculator.promocode)
    )
      return null;

    const userBalance = formatPrice(this.checkoutStore.dependencies.customer?.wallet?.balance || 0, getWalletCurrency(), 'r');
    const availableWalletDiscount = formatPrice(this.checkoutStore.calculator.available_wallet_discount, getWalletCurrency(), 'r');

    return (
      <div className="mb-3">
        <div className="d-flex justify-content-between align-items-center">
          <div className="d-flex flex-column">
            <div className="d-flex align-items-center">
              <p className="text-size-16 mr-2">{localeStore.t('consumer_use_wallet_toggle')}</p>
              <Icon name={Icons.Wallet} className="text-size-16 color-mainblue" />
            </div>
            {appStore.settings?.is_wallet_usage_limit ? (
              <div className="d-flex cursor-pointer mt-1" onClick={this.handleTermsClick}>
                <p className="text-size-12 color-gray2 w-66">
                  {localeStore.t('consumer_wallet_usage_limit_used_from_txt', {
                    available_amount: availableWalletDiscount,
                    amount: userBalance,
                  })}
                </p>
                <Icon name={Icons.Info} className="ml-1 text-size-14 align-self-start color-gray2" />
              </div>
            ) : (
              <p className="text-size-12 color-gray2 mt-2">{userBalance}</p>
            )}
          </div>
          <Switcher status={params.use_wallet as TBooleanInNumber} onChange={this.onChange} />
        </div>
        {params.use_wallet && appStore.settings?.cashback ? (
          <div className="wallet-toggle__warning">
            <div className="divider" />
            <p className="color-gray5 text-size-14 mt-1 text-md-size-14">{localeStore.t('no_cashback_if_wallet_used_infomessage')}</p>
          </div>
        ) : null}
      </div>
    );
  }
}
